import { render, staticRenderFns } from "./AppNavbarHorizontalLayoutBrand.vue?vue&type=template&id=37ab2b04&scoped=true&"
import script from "./AppNavbarHorizontalLayoutBrand.vue?vue&type=script&lang=js&"
export * from "./AppNavbarHorizontalLayoutBrand.vue?vue&type=script&lang=js&"
import style0 from "./AppNavbarHorizontalLayoutBrand.vue?vue&type=style&index=0&id=37ab2b04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ab2b04",
  null
  
)

export default component.exports